import React, { useMemo } from 'react';
import { ScanRuleContext, ScanRuleContextProps, scanRuleSlice } from '../context/ScanRuleContext';
import { ScanRule } from '../types/scan_rule/scanRule';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface ScanRuleProviderProps {
  children: React.ReactNode;
}

export default function ScanRuleProvider({ children }: ScanRuleProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.scanRules.items);
  const loading = useAppSelector(state => state.scanRules.loading);

  const scanRules = useMemo(() => {
    return new Map(items.map(item => [item.id, new ScanRule(item)]));
  }, [items]);

  const scanRuleContext: ScanRuleContextProps = {
    scanRules,
    scanRulesLoading: loading,
    setScanRules: (scanRules: Map<string, ScanRule>) => dispatch(scanRuleSlice.actions.setAll([...scanRules.values()])),
  };

  return <ScanRuleContext.Provider value={scanRuleContext}>{children}</ScanRuleContext.Provider>;
}
